import type { BookingDTO, BookingStatus, TableStatus } from '@six-pockets/shared';
import type { Tone } from '@/components/ui';

export const TABLE_STATUS: Record<TableStatus, { label: string; tone: Tone }> = {
  playing: { label: 'Playing', tone: 'green' },
  paused: { label: 'Paused', tone: 'amber' },
  available: { label: 'Available', tone: 'blue' },
};

export const BOOKING_STATUS: Record<BookingStatus, { label: string; tone: Tone }> = {
  active: { label: 'In play', tone: 'green' },
  paused: { label: 'Paused', tone: 'amber' },
  completed: { label: 'Completed', tone: 'grey' },
};

/** Status shown on a booking's dot: an ended booking that still needs a bill is yellow. */
export function bookingDotStatus(booking: Pick<BookingDTO, 'status' | 'billStatus'>) {
  if (booking.status === 'completed' && booking.billStatus === 'unbilled') {
    return { label: 'Completed · unbilled', tone: 'yellow' as Tone };
  }
  return BOOKING_STATUS[booking.status];
}
